"use client";

import { useEffect, useState } from "react";
import { cn } from "@/lib/utils";

/** Spis treści z podświetleniem sekcji, która jest właśnie czytana. */
export function LegalToc({ items }: { items: { id: string; title: string }[] }) {
  const [active, setActive] = useState<string | null>(null);

  useEffect(() => {
    const io = new IntersectionObserver(
      (entries) => {
        const visible = entries.find((e) => e.isIntersecting);
        if (visible) setActive(visible.target.id);
      },
      { rootMargin: "-20% 0px -70% 0px" }
    );
    items.forEach((it) => {
      const el = document.getElementById(it.id);
      if (el) io.observe(el);
    });
    return () => io.disconnect();
  }, [items]);

  return (
    <nav aria-label="Spis treści" className="sticky top-28">
      <p className="mb-3 px-3 text-xs font-medium uppercase tracking-wide text-primary">Spis treści</p>
      <ul className="space-y-0.5 border-l border-black/[0.08]">
        {items.map((it) => (
          <li key={it.id}>
            <a
              href={`#${it.id}`}
              className={cn(
                "-ml-px block border-l-2 py-1.5 pl-3 text-sm leading-snug transition-colors",
                active === it.id
                  ? "border-primary font-medium text-primary"
                  : "border-transparent text-muted-foreground hover:text-foreground"
              )}
            >
              {it.title}
            </a>
          </li>
        ))}
      </ul>
    </nav>
  );
}
